
module.formDirective('enrollmentStartDateFormOld', directive);

// @ngInject
function directive(moment) {
    return {
        modelName: 'student',
        subModel: 'enrollment',
        fields: ['enrollment_start'],
        formName: 'enrollment_start',
        scope: {'duration': '='},
        link: function(scope, element, attrs) {

            scope.maxDate = null;
            scope.isMaxBirthday = false;

            function refereshMaxDate() {
                // Find the students 30th birthday
                var thirtieth = moment(scope.student.birth_date).add(30, 'years');

                // If the student has exited, and that exit date is before
                // the student's 30th birthday, the max start date is the exit
                // date.  Otherwise it is the 30th birthday.
                if (scope.duration.duration_end && (
                        !thirtieth.isValid() ||
                        thirtieth.isAfter(scope.duration.duration_end))) {
                    scope.maxDate = scope.duration.duration_end;
                    scope.isMaxBirthday = false;
                } else {
                    scope.maxDate = thirtieth;
                    scope.isMaxBirthday = true;
                }
                console.log(scope.maxDate, scope.isMaxBirthday);
            }

            scope.$watchGroup(['student.birth_date', 'duration.duration_start'],
                refereshMaxDate);
        }
    };
}


module.directive('enrollmentStartDateForm', function(ModelService, moment) {
    return {
        restrict: 'E',
        templateUrl: 'students/enrollment/enrollmentStartDateForm',
        scope: {duration: '=', birthDate: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = ModelService.copyFields(scope.duration, ['duration_start'])
            basicForm.data = scope.data;
            scope.form = basicForm.getForm();

            scope.maxDate = null;
            scope.isMaxBirthday = false;

            function refereshMaxDate() {
                // Find the students 30th birthday
                var thirtieth = moment(scope.birthDate).add(30, 'years');

                // If the student has exited, and that exit date is before
                // the student's 30th birthday, the max start date is the exit
                // date.  Otherwise it is the 30th birthday.
                if (scope.duration.duration_end && (
                        !thirtieth.isValid() ||
                        thirtieth.isAfter(scope.duration.duration_end))) {
                    scope.maxDate = scope.duration.duration_end;
                    scope.isMaxBirthday = false;
                } else {
                    scope.maxDate = thirtieth;
                    scope.isMaxBirthday = true;
                }
            }

            scope.$watchGroup(['birthDate', 'duration.duration_start'],
                refereshMaxDate);

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.duration, data);
            }
        },
    };
});
